import type { FlowInstanceEventNotification } from '../../../components/NotificationContext';
import { FlowInstanceStatus } from '../../../api/api';

export function getLatestFlowActivityEvent(events: FlowInstanceEventNotification[], instanceId: string | null | undefined) {
	return events
		.filter((event) => event.payload.id === instanceId && event.payload.currentActivityId !== undefined)
		.sort((left, right) => new Date(right.payload.occurredAt).getTime() - new Date(left.payload.occurredAt).getTime())[0];
}

export function getFlowInstanceLiveState<T extends { id: string; updatedDate: string; status: FlowInstanceStatus; currentActivityId?: string }>(
	instance: T | undefined,
	events: FlowInstanceEventNotification[],
): T | undefined {
	if (!instance) {
		return instance;
	}

	const newerEvents = events
		.filter((event) => event.payload.id === instance.id && new Date(event.payload.occurredAt).getTime() > new Date(instance.updatedDate).getTime())
		.sort((left, right) => new Date(right.payload.occurredAt).getTime() - new Date(left.payload.occurredAt).getTime());
	const statusEvent = newerEvents.find((event) => event.payload.status);
	const activityEvent = getLatestFlowActivityEvent(newerEvents, instance.id);
	const progressEvent = newerEvents.find((event) => event.payload.stepType);
	const progressAfterStatus = progressEvent && (!statusEvent || new Date(progressEvent.payload.occurredAt) > new Date(statusEvent.payload.occurredAt));
	return {
		...instance,
		status: progressAfterStatus ? FlowInstanceStatus.Running : (statusEvent?.payload.status as FlowInstanceStatus | undefined) ?? instance.status,
		currentActivityId: activityEvent ? activityEvent.payload.currentActivityId ?? undefined : instance.currentActivityId,
	};
}
